import {Component, Input, OnDestroy, OnInit, input} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import * as fromProfile from '../../store/profile.reducers';
import {Store} from '@ngrx/store';
import * as fromApp from '../../../store/app.reducers';
import {ActivatedRoute, Params} from '@angular/router';
import * as ProfileActions from '../../store/profile.actions';
import * as DemoActions from '../../../demo/store/demo.actions';

@Component({
    selector: 'app-user-rank',
    templateUrl: './user-rank.component.html',
    styleUrls: ['./user-rank.component.scss'],
    standalone: false
})
export class UserRankComponent implements OnInit, OnDestroy {

  readonly auditType = input<'profile' | 'demo'>(undefined);
  @Input() id: number;
  profileState: Observable<fromProfile.State>;
  routeSubscription: Subscription;
  code: string;
  type: number;

  constructor(
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.type = 1;
    this.profileState = this.store.select(this.getAuditType());
    this.routeSubscription = this.route.params.subscribe(
      (params: Params) => {
        if (params.id !== undefined) {
          this.id = params.id;
        }
        this.code = params.code;

        if (this.getAuditType() === 'profile') {
          this.getProfile(1);
        }
      }
    );
  }

  addProfileAudit(profile: string) {
    this.store.dispatch(
      new ProfileActions.AddAuditCheck({profile: profile, channelType: 'instagram', redirect: false})
    );
  }

  getProfile(type) {
    this.type = type;
    this.store.dispatch(
      new ProfileActions.GetUsersRank({
        id: this.id,
        type: this.type,
        limit: 10,
        offset: 0,
        sortField: 'follower',
        sortType: 'desc',
        params: {
          code: this.code
        }
      })
    );
  }

  getAuditType(): 'profile' | 'demo' {
    const auditType = this.auditType();
    if (auditType === undefined) {
      return 'profile';
    }
    return auditType;
  }

  getAuditActions() {
    const auditType = this.auditType();
    if (auditType === undefined || auditType === 'profile') {
      return ProfileActions;
    } else if (auditType === 'demo') {
      return DemoActions;
    }
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }

}
